import { ExternalLink } from "lucide-react";
import Badge from "@/components/shared/Badge/Badge";

export const integrationFieldPresets = {
  access_token: {
    key: "access_token",
    render: (item: any) => (
      <span className="bg-[#27272a] flex items-center gap-4 w-fit rounded-md p-1">
        {item.access_token}
      </span>
    ),
  },

  secret_token: {
    key: "secret_token",
    render: (item: any) => (
      <span className="bg-[#27272a] flex items-center gap-4 w-fit rounded-md p-1">
        {item.secret_token}
      </span>
    ),
  },

  postback_url: {
    key: "postback_url",
    render: (item: any) => (
      <a
        href={item.postback_url}
        target="_blank"
        rel="noreferrer"
        className="bg-[#27272a] flex items-center gap-4 w-fit rounded-md p-1"
      >
        <span>{item.postback_url}</span>
        <ExternalLink className="cursor-pointer text-muted" width={18} height={18} />
      </a>
    ),
  },

  metadata: {
    key: "metadata",
    render: (item: any) => (<></>),
  },

  status: {
    key: "status",
    render: (item: any) => (
      <Badge status={item.status ? "active" : "inactive"} />
    ),
  },
};
